/**
 * Config file for `react-shortcuts` plugin.
 */

export const keymap = {
  APP_SHORTCUTS: {
    EDGE: 'alt+e'
  },
};
